import React from "react";

const GlobalSettings = () => {
  return <div>GlobalSettings</div>;
};

export default GlobalSettings;
